import React from 'react'
import { Stack, SimpleTabs } from '@/components/lib'
import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'
import utils from '../../../utils/utils'

import General from './General'
import Integrations from './Integrations'
import Events from './Events'
import CommLogs from './CommLogs'
import Locks from './Locks'
import Delete from './Delete'
import Wallet from './Wallet'
import Scorch from './Scorch'

export default function Settings () {
  const { user, trial } = useStore()
  useTitle('Settings', trial)

  const base = `/trials/${trial?._id}/settings`
  const tabs = [
    { title: 'Participation', to: `${base}/participation`, content: <General user={user} trial={trial} /> },
    { title: 'Integrations', to: `${base}/integrations`, content: <Integrations user={user} trial={trial} /> },
    { title: 'Scorch', to: `${base}/scorch`, content: <Scorch trial={trial} /> },
    utils.canManageTrialWallet(user, trial) && { title: 'Wallet', to: `${base}/wallet`, content: <Wallet trial={trial} /> },
    { title: 'Logs', to: `${base}/logs`, content: <Events trial={trial} /> },
    { title: 'Comms', to: `${base}/comms`, content: <CommLogs trial={trial} /> },
    { title: 'Locks', to: `${base}/locks`, content: <Locks /> },
    { title: 'Delete trial', to: `${base}/delete`, content: <Delete trial={trial} /> }
  ].filter(Boolean)

  return (
    <Stack gap={5}>
      <SimpleTabs lazyMount tabs={tabs} />
    </Stack>
  )
}
